import type { TenantConfig } from '@/types/TenantConfig'

const white = '#FFFFFF'
const orange = '#ED8B00'
const navy = '#002554'
const teal = '#00617F'
const gray = '#eceeef'

export const cosi: TenantConfig = {
  logo: 'assets/cosi/static/logo.svg',
  teaserImageSize: {
    width: 320,
  },
  themeOptions: {
    primaryColor: teal,
    secondaryColor: orange,
    headerBackground: 'url(/assets/cosi/static/bg.gif)',
    memberLinksColor: white,
    memberLinksColorHover: white,
    cartHeaderBackgroundColor: gray,
    footerBackgroundColor: navy,
    footerTextColor: white,
    headerHeight: '120px',
    logoHeight: '100px',
    dialog: {
      headerBackground: gray,
      headerTextColor: 'black',
      headerIconColor: 'black',
    },
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/cosi/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-120px',
        mobile: '-80px',
      },
    },
  },
  i18nOverrides: {
    en: {
      checkoutRoute: {
        title: 'Payment Information',
      },
    },
  },
}
